type ViteEnv = Partial<ImportMetaEnv> & {
  readonly PROD?: boolean;
};

function assertNonEmptyString(value: unknown, name: string): asserts value is string {
  if (typeof value !== 'string' || value.trim().length === 0) {
    throw new Error(`${name} must be a non-empty string`);
  }
}

function isLocalhostUrl(value: string): boolean {
  return /^(http|https):\/\/(localhost|127\.0\.0\.1)(:|\/|$)/i.test(value);
}

export function requireEnvUrl(
  name: keyof ImportMetaEnv & string,
  env: ViteEnv = import.meta.env
): string {
  const rawValue = env[name];
  assertNonEmptyString(rawValue, name);

  const normalized = rawValue.trim().replace(/\/+$/, '');
  if (normalized.length === 0) {
    throw new Error(`${name} must be a non-empty string`);
  }

  if (env.PROD && isLocalhostUrl(normalized)) {
    throw new Error(`${name} must not point to localhost in production`);
  }

  return normalized;
}
